import React, { useContext, useEffect, useState } from "react";
import Layout from "../../component/layout/Layout";
import { useFormik } from "formik";
import AllApplications from "../../sections/AllApplications";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { addFilterData } from '../../features/filter/filterSlice';

import * as Icon from 'lucide-react';
import {
  applyAllFilterService,
  getAllFilterService,
  getAllFilterEmployee
} from "../../services/applicationService";
import { rootContexts } from "../../contexts/rootContexts";
import Sidebar from "../../component/layout/Sidebar";
import Pagination from '@mui/material/Pagination';

const Lmia = () => {
  const token = localStorage.getItem("token");
  const { setAsLogin } = useContext(rootContexts);
  // const {asLoginSuccess} = useContext(rootContexts)
  const [filterData, setFilterData] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [singleLoad, setsingleLoad] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currrentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [asSubmit,setAsSubmit]=useState(false);
  const [asSearch,setAsSearch]=useState(false);
  const [searchValue,setSearchValue]=useState('');
  const [sorting, setSorting] = useState([]);
  const [tableStatus,setTableStatus] = useState('');
  const [rowPerPage,setRowPerPage] = useState('10');
  const [count,setCount] = useState(0);
   

  const navigate = useNavigate();
  
  const formik = useFormik({
    initialValues: {
      years: [], // Make sure it's an array
      quarters: [],
      program_streams: [],
      provinces: [],
      cities: [],
      employers: [],
      statuses: "",
      nocs: [],
      statuses:"Positive",
      
    },
    onSubmit: async (values) => {
      setIsLoadingUsers(true);
      setAsSubmit(true)
      setAsSearch(false)
      const result = await applyAllFilterService(values,currrentPage,sorting,rowPerPage);

      if (result?.status) {
        setIsLoadingUsers(false);
       
        setTableData(result.data?.data);
        setLastPage(result.data?.last_page);
        setTableStatus('filter')
      } else {
        setIsLoadingUsers(false);
      }
    },
  });
// function for react box select data start
function convertObjectToReactSelect(arr) {
  return arr.map((value, index) => ({ value: value, label: value }));
}

// function for react box select data end

  const getDefaultFilterData = async (page=1) => {
    const result = await applyAllFilterService({},page,sorting,rowPerPage);
    setIsLoadingUsers(true);
    if (result?.status) {
      setTableStatus('default')
      setsingleLoad(false);
      setIsLoadingUsers(false);
      setTableData(result.data?.data);
      setLastPage(result.data?.last_page);
      
    } else {
      setIsLoadingUsers(false);
    }
  };

  // const getDefaultEmployee = async (data) => {
  //   const result = await applyAllFilterService(data);
  //   console.log(result,'result============>>>')
  //   setIsLoadingUsers(true);
  //   if (result?.status) {
  //     setTableStatus('default')
  //     setsingleLoad(false);
  //     setIsLoadingUsers(false);
  //     setEmployee(result.data?.data);
      
  //   } else {
  //     setIsLoadingUsers(false);
  //   }
  // };

  const handleGetAllFilter = async () => {
    setIsLoading(true);
   
    
    const result = await getAllFilterService();
    if (result?.status) {
      if(result.data) {
       
        setIsLoading(false);
        for (let key in result.data) {
          result.data[key] = convertObjectToReactSelect(result.data[key]);
        }
        setFilterData(result.data);
        localStorage.setItem('years',JSON.stringify(result.data.year.slice(0,3).map(e=>e.value)));
        
      } else {
        setIsLoading(false);
      }
    }
  };


  // search filter start
  const getSearchFilterData = async (search,page) => {
    setSearchValue(search)
    setAsSearch(true)
    setIsLoadingUsers(true);
    console.log("the value of row per Page",rowPerPage)
    const result = await applyAllFilterService({
      search_field:search,
   
    },page,sorting,rowPerPage);
    setIsLoadingUsers(true);
    if (result?.status) {
      setAsSearch(true)
      setTableStatus('search')
     setCurrentPage(page)
      setsingleLoad(false);
      setIsLoadingUsers(false);
      setTableData(result.data?.data);
      setLastPage(result.data?.last_page);
      
    } else {
      setAsSearch(false)
      setIsLoadingUsers(false);
    }
  };
  // search filter end

  // hand row per Page start
  const handleRowPerPageChange = (event) => {
    // const per_page=;
    setRowPerPage(event.target.value);
   
    setCurrentPage(1);
    // if(tableStatus==='default'){
    //   getDefaultFilterData(1)
    //  }
    //  else if(tableStatus==='search'){
    //   getSearchFilterData(searchValue,1)
    //  }
     
    //  else if(tableStatus==='filter'){
    //     formik.handleSubmit();
    //  }
  };
  // hand row per Page end
  useEffect(() => {
    if (!token) {
      setAsLogin(true);
      navigate("/");
    }
   
    if (tableData.length === 0 && singleLoad) {
      getDefaultFilterData(currrentPage);
    }
  });


useEffect(()=>{
       if(count===0){
        setCount(1)
         const yearData =JSON.parse(localStorage.getItem('years')) ||[];
        if(yearData.length >0){
          formik.setFieldValue('years',yearData);
        }
        else{
          formik.setFieldValue('years',['All']);
        }
        
        formik.setFieldValue('quarters',["All"]);
        formik.setFieldValue('program_streams',["All"]);
        formik.setFieldValue('provinces',["All"]);
        formik.setFieldValue('cities',["All"]);
        formik.setFieldValue('employers',["All"]);
        formik.setFieldValue('nocs',["All"]);
  handleGetAllFilter()
      }
},[])

useEffect(() => {
 if(tableStatus==='default'){
  getDefaultFilterData(currrentPage)
 }
 else if(tableStatus==='search'){
  getSearchFilterData(searchValue,currrentPage,rowPerPage)
 }
 
 else if(tableStatus==='filter'){
    formik.handleSubmit();
 }

  console.log("the sorting is",sorting[0]);
}, [sorting,rowPerPage]);


  return (
    <Layout>
      <div className="">
        <div className="bg-primary h-[100px] flex justify-end  items-center w-full">
          {/* <!-- Hamburger Toggle BTN --> */}
          <button
            aria-controls="sidebar"
            onClick={() => {
              setSidebarOpen(!sidebarOpen);
            }}
            className=" block border-none   text-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
          >
            <Icon.ArrowRightToLine size={50}/>
          </button>
          {/* <!-- Hamburger Toggle BTN --> */}
          <div className="container">
            <div className="flex flex-wrap items-center ">
              <div className="w-full px-4">
                <div className="text-center">
                  <h1 className="font-semibold text-white text-4xl uppercase">
                    LMIA Database
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="  ">
        <div className="flex h-screen overflow-hidden">
          <Sidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            formik={formik}
            isLoading={false}
            filterData={filterData}
            setCurrentPage={setCurrentPage}
          />

          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden custom-scroll pb-10">
            <AllApplications
              tableData={tableData}
              isLoadingUsers={isLoadingUsers}
              getSearchFilterData ={getSearchFilterData}
              setSorting={setSorting}
              sorting={sorting}
            />
             <div className="flex flex-col md:flex-row pr-10 justify-center md:justify-between items-center w-full">
    <div className="w-full md:w-8/12">
    {!isLoadingUsers ?
          <Pagination
        
          color="primary"
          showFirstButton
          showLastButton
          page={currrentPage}
          count={lastPage}
          onChange={(event,page)=>{
          
            setCurrentPage(page)
            setIsLoadingUsers(true);
            if(asSubmit){

              formik.handleSubmit();
            }
            else{
              if(!asSearch){

                getDefaultFilterData(page);
              }
              else{
               
                getSearchFilterData(searchValue,page)
              }
            }

          }}
          size="large"
          
          style={{
            cursor: "pointer",
            marginLeft: "20px",
          }}
          />
           : null}
    </div>
       <div className="flex relative items-center gap-x-3 justify-end w-full md:w-4/12">
        <span>Rows per page </span>
       <select className="border border-gray-400 rounded-md  focus:border-gray-500 focus:outline-none ring-0 focus:ring-0"
       onChange={handleRowPerPageChange}
       value={rowPerPage}
       >
  <option value="10">10</option>
  <option value="20">20 </option>
  <option value="50">50 </option>
  <option value="100">100 </option>
          </select>
       </div>
        </div>
            {/* } */}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Lmia;
